import { render, staticRenderFns } from "./RedirectToKionButton.vue?vue&type=template&id=5ed0eda4"
import script from "./RedirectToKionButton.vue?vue&type=script&lang=ts"
export * from "./RedirectToKionButton.vue?vue&type=script&lang=ts"
import style0 from "./RedirectToKionButton.vue?vue&type=style&index=0&id=5ed0eda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports